import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {configuration} from '../../../../../../configuration'
const API_URL = configuration.apiUrl
const PARTY_URL = `${API_URL}/parties`
const DeletePartyLedger_URL = `${API_URL}/messages/deleteTransaction`
const New_DeletePartyLedger_URL = `${API_URL}/message/deleteTransaction`

const PartyLedger_URL = `${API_URL}/parties/partyLedger`
const tallyLedger = `${API_URL}/ledgerentries/tallyLedger`
const IS_TALLY_URL = `${API_URL}/message/tallyLedger`
const HO_DETAIL_URL = `${API_URL}/ledgerentries/getHoDetail`
const Message_URL = `${API_URL}/messages`
const MONDAYFINALBYID_URL = `${API_URL}/messages/approveByLedger`
const ONLY_PARTY_URL = `${API_URL}/parties/onlyPartys`
const GET_PARTYLISTING_URL = `${API_URL}/party/getPartyListing`
const GET_PARTY_BRANCHLEDGER = `${API_URL}/party/branchLedger`
const GET_PARTY_BRANCHLEDGER_LISTING = `${API_URL}/party/v1/branchLedger`

export const getUsers = (query: string): Promise<any> => {
  return axios.get(`${ONLY_PARTY_URL}`).then((d: AxiosResponse<any>) => d.data)
}

export const getParty = (): Promise<any> => {
  return axios.get(`${GET_PARTYLISTING_URL}`).then((d: AxiosResponse<any>) => d.data)
}

export const getPartyFilter = (): Promise<any> => {
  return axios
    .get(GET_PARTYLISTING_URL, {
      params: {
        "filter[orderBy]": "party_code ASC",
        "filter[partycode]": "null",
      },
    })
    .then((d: AxiosResponse<any>) => d.data)
    .catch((error) => {
      console.error("Error fetching party listing:", error);
      throw error;
    });
};

export const branchLedgerWithPartyId = (partyId: number): Promise<any> => {
  return axios
    .get(`${GET_PARTY_BRANCHLEDGER}/${partyId}`, {
      params: {
        orderBy: "created_date ASC",
        "filter[fromdate]": "2025-03-18",
        "filter[todate]": "2025-03-18",
        "filter[limit]": 100,
        "filter[offset]": 0,
      },
    })
    .then((d: AxiosResponse<any>) => d.data)
    .catch((error) => {
      console.error("Error fetching branch ledger:", error);
      throw error;
    });
};
const getPartyLedger = (query: string, id: any): Promise<any> => {
  return axios.get(`${GET_PARTY_BRANCHLEDGER}/${id}?${query}`).then((d: AxiosResponse<any>) => d.data)
}
const getPartyLedgerList = (query: string, id: any): Promise<any> => {
  const params = new URLSearchParams(query);

  // Extract sort and order values
  const sort = params.get("sort");
  const order = params.get("order")?.toUpperCase();

  // Remove sort and order from query params
  params.delete("sort");
  params.delete("order");

  // Append filter[orderBy] if sort and order exist
  if (sort && order) {
    params.set("filter[orderBy]", `${sort} ${order}`);
  }
  return axios.get(`${GET_PARTY_BRANCHLEDGER_LISTING}/${id}?${params.toString()}`).then((d: AxiosResponse<any>) => d.data)
}

const getHoDetail = (): Promise<any> => {
  return axios.get(`${HO_DETAIL_URL}`).then((d: AxiosResponse<any>) => d.data)
}

const getPartyLedgerById = (id: any): Promise<any> => {
  return axios
    .get(`${PARTY_URL}/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const TallyLedger = (data: any, id: any): Promise<any> => {
  return axios
    .patch(`${IS_TALLY_URL}/${id}`, data)
    .then((response: AxiosResponse<Response<any>>) => response)
}

const deletePartyLedger = (id: any, payload: { password: string }): Promise<any> => {
  return axios
    .delete(`${New_DeletePartyLedger_URL}/${id}`, {
      data: payload, // Ensure password is sent in the request body
    })
    .then((response: AxiosResponse<Response<any>>) => response)
    .catch((error) => {
      console.error("API Error:", error);
      throw error; // Ensure error is propagated to deleteAction
    });
};


const MondayFinalById = (id: any): Promise<any> => {
  return axios
    .get(`${MONDAYFINALBYID_URL}/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const TallyAllMessages = (data: any, id: any): Promise<any> => {
  return axios
    .patch(`${tallyLedger}/${id}`, data)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

const deleteSelectedPartyLedger = (PartyLedgerIds: Array<ID>): Promise<void> => {
  const requests = PartyLedgerIds.map((id) => axios.delete(`${PARTY_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

const getMessageById = (id: any): Promise<any> => {
  return axios
    .get(`${Message_URL}/${id}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}

export {
  // getUsers,
  deletePartyLedger,
  getPartyLedgerList,
  deleteSelectedPartyLedger,
  getPartyLedgerById,
  MondayFinalById,
  TallyLedger,
  getPartyLedger,
  getHoDetail,
  getMessageById,
  TallyAllMessages,
}
